import { Dialog } from 'quasar'
import { userAbortError } from 'src/consts.js'

export function showInfoDialog(message, title) {
    return Dialog.create({
        title: title || null,
        message: message || null,
        color: 'info',
        html: true,
        noRouteDismiss: true,
        noFocus: true,
    })
}

export function showErrorDialog(message = null, title = null) {
    return Dialog.create({
        title: title || trans('errors_whoops'),
        message: message || trans('errors_unknown_error'),
        color: 'warning',
        html: true,
        noRouteDismiss: true,
        noFocus: true,
        actions: [
            { label: trans('dismiss'), color: 'white' },
        ],
    })
}

// Get the user to confirm an action
export function confirmAction(message, title, color = 'positive') {
    let dialog = Dialog.create({
        title,
        message,
        color,
        noFocus: true,
        cancel: { label: trans('cancel'), color: 'white', textColor: 'black' },
        ok: { label: trans('proceed') },
    })

    return new Promise((resolve, reject) => {
        dialog
            .onOk(() => resolve(true))
            .onCancel(() => reject(userAbortError))
    })
}

export function confirmWithPrompt(message, title, color='positive') {
    let dialog = Dialog.create({
        title,
        message,
        color,
        noFocus: true,
        cancel: { label: trans('cancel'), color: 'white', textColor: 'black' },
        ok: { label: trans('proceed') },
        prompt: {
            model: '',
            isValid: val => val.length > 2,
            type: 'text',
        },
    })

    return new Promise((resolve, reject) => {
        dialog
            .onOk((data) => resolve(data))
            .onCancel(() => reject(userAbortError))
    })
}

export function confirmDelete(entityType, specificName = null) {
    return confirmAction(
        specificName
            ? trans('confirm_delete_name', { name: specificName })
            : trans('confirm_delete', { what: entityType }),
        trans('delete_what', { what: entityType }),
        'negative',
    )
}

// Generic yes/no confirm dialog
export function confirmYesNo(message, title, opts = {}) {
    let dialog = Dialog.create({
        title,
        message,
        noFocus: true,
        ok: { label: trans('yes'), color: 'primary' },
        cancel: { label: trans('no'), flat: true },
        ...opts,
    })

    return new Promise(resolve => {
        dialog
            .onOk(() => resolve(true))
            .onCancel(() => resolve(false))
    })
}

// Show a dialog asking user whether they want to discard their form
export function confirmFormLeave(hasUnsavedChanges, next) {
    if (!hasUnsavedChanges) return next()

    let dialog = Dialog.create({
        title: trans('errors_unsaved_changes_title'),
        message: trans('errors_unsaved_changes_message'),
        cancel: true,
        noFocus: true,
        color: 'negative',
        ok: { label: trans('discard_changes') },
    })

    dialog
        .onOk(() => next())
        .onCancel(() => next(false))
}

// Confirm whether the user would like to refresh the given entity name
export function confirmRefresh(entityName) {
    let dialog = Dialog.create({
        title: trans('external_data_refresh'),
        message: trans('confirm_manual_refresh', { what: entityName }),
        noFocus: true,
        ok: { label: trans('yes'), color: 'primary' },
        cancel: { label: trans('no'), flat: true },
    })

    return new Promise((resolve, reject) => {
        dialog
            .onOk(() => resolve(true))
            .onCancel(() => reject(userAbortError))
    })
}
